import React, { Component } from 'react';
import { Row, Col, Container, Form, Button } from 'react-bootstrap';
import FormInput from './FormFields/FormInput';
import FormSelect from './FormFields/FormSelect';
import FormValueOnly from './FormFields/FormValueOnly';
import { Query, Mutation } from '@apollo/client/react/components';

/** Class Requirements:
 *      - The object returned by the getDataQuery must be a single object, not an array
 *      - The update mutation should be set up to take a single argument named "input". This component
 *          will construct the correct input object to update based on the fieldModel's "name" key and the
 *          values pulled from the form.
 */

export default class DynamicForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      fieldModel: this.props.fieldModel,
      readOnlyForm: this.props.readOnly || false,
      hasError: false,
    };
  }

  _handleChange = (event, fieldName) => {
    // We don't care about the changes, but an event handler needs to be
    // provided to the input element or it renders as readonly
    let newFieldValue = {};
    newFieldValue[fieldName] = event.target.value;
    this.setState({ formData: newFieldValue });
  };

  _handleSubmit = (event, submitFn, fieldModel) => {
    event.preventDefault(); // Make user close modal because we'll lose filters on the grid when page refreshes
    var submitValues = {};
    fieldModel.map((field) => {
      if (field.gqlDataType === 'number') {
        submitValues[field.name] = Number(event.target[field.name].value);
      } else if (field.gqlDataType === 'boolean') {
        submitValues[field.name] = event.target[field.name].value === 'true';
      } else if (field.name === 'deliveryDate') {
        submitValues[field.name] = event.target[field.name].value === '' ? null : event.target[field.name].value;
        //prompt(event.target[field.name].value);
      } else {
        submitValues[field.name] = event.target[field.name].value;
      }
      return '';
    });
    submitFn({ variables: { input: submitValues } });
  };

  renderSaveFeedback = (error, data) => {
    if (error) {
      console.log(error);
      return (
        <span className='elementFadeInAndOut'>
          <i className='fa fa-times-circle'></i> Error Saving Form
        </span>
      );
    } else if (data && !error) {
      return (
        <span className='elementFadeInAndOut'>
          <i className='fa fa-check-circle'></i> Success - Form Saved
        </span>
      );
    } else {
      // Probably just rendering the initial form, no need for feedback yet
    }
  };

  renderDeleteFeedback = (error, data) => {};

  renderButtons = (isReadonlyForm, mutationError, mutationData) => {
    if (isReadonlyForm) return '';
    else {
      return (
        <Col sm={{ span: 10, offset: 2 }}>
          <Button type='submit' variant='success'>
            Save Changes
          </Button>
          {this.renderSaveFeedback(mutationError, mutationData)}
          <Button variant='warning' className='float-right' onMouseUp={() => alert('this will delete the entry...')} type='submit'>
            Delete Item
          </Button>
          {this.renderDeleteFeedback}
        </Col>
      );
    }
  };

  renderForm = (data, model, mutationError, mutationData) => {
    let formUI = model.map((field, index) => {
      let type = field.type;

      switch (type) {
        case 'input':
          return (
            <FormInput
              formData={data[field.name]}
              key={index}
              fieldModel={field}
              readOnly={field.readOnly || this.state.readOnlyForm}
              onChange={(event) => this._handleChange(event, field.name)}
            />
          );
        case 'select':
          return (
            <FormSelect
              formData={data[field.name]}
              key={index}
              fieldModel={field}
              readOnly={field.readOnly || this.state.readOnlyForm}
              onChange={(event) => this._handleChange(event, field.name)}
            />
          );
        default:
          return <FormValueOnly formData={data[field.name]} key={index} fieldModel={field} />;
      }
    });

    return (
      <Row>
        <Col md={{ span: 8 }}>
          <Container>
            <Row>
              <Col sm={{ span: 7, offset: 1 }}>
                <legend>{this.props.title}</legend>
              </Col>
            </Row>
            {formUI}
            <Form.Group as={Row}>{this.renderButtons(this.state.readOnlyForm, mutationError, mutationData)}</Form.Group>
          </Container>
        </Col>

        <Col md={{ span: 4 }}>
          {/* <Container>
                            <Comments
                                getComment={this.props.getComment}
                                setComment={this.props.setComment}
                                barCode={this.props.currentBarcode}
                            />
                            </Container> */}
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div>
        <h3>{this.props.title}</h3>
        <Container fluid>
          <Query query={this.props.getDataQuery} variables={this.props.queryVars} fetchPolicy='no-cache'>
            {({ loading, error, data }) => {
              if (loading) return <p>Loading...</p>;
              if (error)
                return (
                  <div className='alert alert-danger' role='alert'>
                    Error
                  </div>
                );
              //console.log(data);
              let queryData = data;
              console.log('Data from query with vars:');
              console.log(this.props.queryVars);
              console.log(queryData);

              return (
                <Mutation mutation={this.props.setDataMutation} errorPolicy='all'>
                  {(mutationFn, { loading, error, data }) => {
                    console.log('Data from mutation:');
                    console.log(data);
                    console.log('Error from mutation:');
                    console.log(error);
                    return (
                      <div>
                        <Form
                          onSubmit={(e) => {
                            this._handleSubmit(e, mutationFn, this.state.fieldModel);
                          }}>
                          {this.renderForm(queryData[this.props.getDataResolverName], this.state.fieldModel, error, data)}
                        </Form>
                      </div>
                    );
                  }}
                </Mutation>
              );
            }}
          </Query>
        </Container>
      </div>
    );
  }
}
